import { useEventListener } from '@nucleus/react-components/src/hooks/useEventListener';
import { type AuthUser, getCurrentUser } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';
import { useCallback, useEffect, useState } from 'react';

const getAuthenticatedUser = async (): Promise<AuthUser | undefined> => {
  try {
    return await getCurrentUser();
  } catch (error) {
    return;
  }
};

export const useAuthentication = (): [boolean, AuthUser | undefined] => {
  const [user, setUser] = useState<AuthUser | undefined>();

  const loadCurrentUser = useCallback(async () => {
    setUser(await getAuthenticatedUser());
  }, []);

  useEffect(() => {
    loadCurrentUser();
  }, [loadCurrentUser]);

  useEffect(() => {
    const unsubscribe = Hub.listen('auth', () => {
      loadCurrentUser();
    });
    return unsubscribe;
  }, [loadCurrentUser]);

  useEventListener('NucleusUserSignedIn', () => loadCurrentUser());
  useEventListener('NucleusUserSignedOut', () => loadCurrentUser());

  const isAuthenticated = user !== undefined;

  return [isAuthenticated, user];
};

export const useAuthBroadcast = (): void => {
  const [isAuthenticated] = useAuthentication();

  useEffect(() => {
    if (isAuthenticated === false) {
      window.dispatchEvent(new CustomEvent('NucleusWebSignedOut'));
    }
  }, [isAuthenticated]);
};
